export const GET_THEMES_SUCCESS = "GET_THEMES_SUCCESS";
export const THEMES_LOADING = "THEMES_LOADING";
export const SET_THEME = "SET_THEME";
export const GET_THEME_DETAILS_SUCCESS = "GET_THEME_DETAILS_SUCCESS";
export const GET_SCROLL_THEMES_SUCCESS = "GET_SCROLL_THEMES_SUCCESS";
